
function assetQuickPreviewDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/asset-quick-preview-dialog/asset-quick-preview-dialog.html?$$REVISION$$'
  }
}
export { assetQuickPreviewDialog }
